import type { SxProps, Theme } from '@mui/material';

export const styles = {
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        py: '10px',
        px: { xs: '12px', sm: '24px', md: '40px' },
        alignItems: 'center',
        gap: { xs: 1, md: 2 },
    } as SxProps<Theme>,
    logoBox: {
        flex: '1 1 auto',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, md: 2 },
    } as SxProps<Theme>,
    menuButton: {
        display: { xs: 'inline-flex', md: 'none' },
        flexShrink: 0,
    } as SxProps<Theme>,
    logoImg: {
        maxWidth: 200,
        height: 'auto',
        padding: '4px',
        flexShrink: 0,
    } as Record<string, string | number>,
    companyName: {
        color: 'text.primary',
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: { xs: 'none', sm: 'block' },
    } as SxProps<Theme>,
    iconsBox: {
        flex: '0 0 auto',
        display: 'flex',
        justifyContent: 'flex-end',
    } as SxProps<Theme>,
    iconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 0,
        gap: { xs: '8px', md: '16px' },
        height: '56px',
    } as SxProps<Theme>,
    headerIconBtn: (theme: Theme) => ({
        backgroundColor: theme.palette.grey[100],
        '& .MuiSvgIcon-root': {
            color: theme.palette.grey[800],
        },
    }),
    popper: (theme: Theme) => ({
        boxShadow: theme.shadows[3],
        borderRadius: '8px',
        padding: '8px',
        zIndex: theme.zIndex.modal,
        fontSize: '12px',
        backgroundColor: 'white',
        marginTop: '10px !important',
    }),
    badge: {
        '& .MuiBadge-badge': {
            right: -3,
            top: -3,
        },
    } as SxProps<Theme>,
    notifEmpty: {
        padding: 2,
        minWidth: 280,
        color: 'grey.500',
        textAlign: 'center',
    } as SxProps<Theme>,
    notifList: { minWidth: 320, maxHeight: 360, overflow: 'auto' } as SxProps<Theme>,
    notifItem: (theme: Theme) => ({
        padding: theme.spacing(1.5),
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        cursor: 'pointer',
        '&:hover': { background: theme.palette.grey[30] },
    }),
    notifUnreadDot: (theme: Theme) => ({
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: theme.palette.blue.main,
        mr: 1,
        display: 'inline-block',
    }),
    userMenu: { p: 0, minWidth: 160 } as SxProps<Theme>,
    userMenuItem: (theme: Theme): SxProps<Theme> => ({
        px: 2,
        py: 1.25,
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.grey[900],
        cursor: 'pointer',
        '&:hover': {
            background: theme.palette.blue[40],
            color: theme.palette.blue.main,
        },
    }),
};
